export const filterIcon = require('@assets/icons/filter.webp');
export const downIcon = require('@assets/icons/down.webp');
export const bettingIcon = require('@assets/icons/rebate/betting.webp');
export const rebateIcon = require('@assets/icons/rebate/rebate.webp');
export const closeIcon = require('@components/assets/icons/close.webp');
